export const PAGE_PREVIEW_HEADER = 'X-Diagonal-Page-Preview';
export const PAGE_PREVIEW_HEADER_VALUE = 'true';
export const PAGE_PREVIEW_QUERY_PARAMETER = '_diagonal_preview';
export const PAGE_PREVIEW_QUERY_VALUE = 'page-editor';

export function markPagePreviewUrl(value: string): string {
  if (!window.isPreviewing) {
    return value;
  }

  const url = new URL(value, window.location.href);

  if (url.origin !== window.location.origin) {
    return value;
  }

  url.searchParams.set(PAGE_PREVIEW_QUERY_PARAMETER, PAGE_PREVIEW_QUERY_VALUE);

  return url.toString();
}
